<div class="form-group mb-0 me-3">
    <label for="langselect" class="small collapse">
      {{ 'HEADER.SELECT' | translate }}
    </label>
    <select #langselect aria-label="language select" id="langselect" name="language" (change)="chooseLang(langselect.value)" class="form-control form-control-sm form-select darkselect" [(ngModel)]="browserLang">
      <option *ngFor="let lang of translate.getLangs()" [value]="lang">{{ lang }}</option>
    </select>
  </div>